import { dispatchAppToast } from "@/utils/toast";

/** Routes toasts through App.vue — no local `ToastContainer` required. */
export default {
  methods: {
    showToast(a, b, c) {
      dispatchAppToast(a, b, c);
    },
    showToastMessage(title, message, type) {
      dispatchAppToast(title, message, type);
    },
    emitToast(title, message, type = "info") {
      dispatchAppToast(title, message, type);
    },
  },
};
